import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Doughnut, Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { makeStyles, FormControl, Select, MenuItem, Typography, Grid } from '@material-ui/core';

import Tab from 'src/components/tab';
import { coloredDatasets } from 'src/helpers/chartJsHelpers';
import ChartWrapper from 'src/components/chartWrapper';

import { setTabExpend, setTimeLine } from './slice';

const weekDays = ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const LineChartData = coloredDatasets('line', {
  // labels: ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  datasets: [
    {
      label: 'Last 7 days',
      data: [
        { x: new Date(2018, 11, 24, 0, 0, 0, 0), y: 0.1 },
        { x: new Date(2018, 11, 25, 0, 0, 0, 0), y: 0.4 },
        { x: new Date(2018, 11, 26, 0, 0, 0, 0), y: 0.9 },
        { x: new Date(2018, 11, 27, 0, 0, 0, 0), y: 0.3 },
        { x: new Date(2018, 11, 28, 0, 0, 0, 0), y: 0.5 },
        { x: new Date(2018, 11, 29, 0, 0, 0, 0), y: 0.5 },
        { x: new Date(2018, 11, 30, 0, 0, 0, 0), y: 0.7 },
      ],
      fill: false,
    },
  ],
});

const lineChartOptions = {
  maintainAspectRatio: false,
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        stacked: false,
        ticks: {
          beginAtZero: true,
          padding: 20,
          callback: (value, index, values) => {
            return `${value}s`;
          },
        },
        gridLines: {
          drawTicks: false,
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        offset: true,
        type: 'time',
        // distribution: 'series',
        stacked: false,
        bounds: 'ticks',
        time: {
          unit: 'day',
          tooltipFormat: 'DD. MMM',
          displayFormats: {
            day: 'DD. MMM',
          },
        },
        ticks: {
          padding: 20,
          // source: 'labels',
          beginAtZero: true,
          callback: (value, index, values) => {
            return [weekDays[index], value];
          },
        },
        gridLines: {
          display: false,
          // offsetGridLines: false,
        },
      },
    ],
  },
  legend: {
    display: false,
  },
  tooltips: {
    callbacks: {
      labelColor: (tooltipItem, chart) => {
        const dataset = chart.config.data.datasets[tooltipItem.datasetIndex];
        return {
          backgroundColor: dataset.borderColor,
        };
      },
      label: (tooltipItem, data) => {
        return `${tooltipItem.yLabel}s`;
      },
    },
  },
};

const doughnutChartData = {
  datasets: [
    {
      label: 'Leads posted',
      data: [0.43, 0.15],
      needleValue: 0.43,
      backgroundColor: ['#325A73', '#6BB9B6'],
    },
  ],
};

const doughnutChartOption = {
  // maintainAspectRatio: false,
  cutoutPercentage: 70,
  rotation: 1 * Math.PI,
  circumference: 1 * Math.PI,
  elements: {
    arc: {
      borderWidth: 0,
    },
  },
  tooltips: {
    enabled: false,
  },
};

const plugins = [
  {
    afterDraw: chart => {
      const { needleValue } = chart.chart.config.data.datasets[0];
      const dataTotal = chart.chart.config.data.datasets[0].data.reduce((a, b) => a + b, 0);
      const angle = Math.PI + (1 / dataTotal) * needleValue * Math.PI;
      const { ctx } = chart.chart;
      const cw = chart.chart.canvas.offsetWidth;
      const ch = chart.chart.canvas.offsetHeight;
      const cx = cw / 2;
      const cy = ch - 6;

      ctx.translate(cx, cy);
      ctx.rotate(angle);
      ctx.beginPath();
      ctx.moveTo(0, -6);
      ctx.lineTo(ch - 20, 4);
      ctx.lineTo(0, 6);
      ctx.fillStyle = 'rgb(0, 0, 0)';
      ctx.fill();
      ctx.rotate(-angle);
      ctx.translate(-cx, -cy);
      ctx.beginPath();
      ctx.arc(cx, cy, 6, 0, Math.PI * 2);
      ctx.fill();
    },
  },
];

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 125,
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
    },
  },
  textWrapper: {
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  doughnutChartWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    maxWidth: 215,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0),
    },
  },
  text: {
    marginTop: 25,
  },
}));

const AvgSpeed = props => {
  const { isTabExpended, timeLine } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title7 {
                html
                text
                raw
              }
              titleTooltip7 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  const handelChange = event => {
    props.setTimeLine(event.target.value);
  };

  return (
    <Tab
      title={prismicData.title7.text}
      tooltipedText={prismicData.titleTooltip7.text}
      drag
      onClick={handelExpand}
      expanded={isTabExpended}
    >
      {/* <div>
        <FormControl variant="outlined" color="secondary" size="small" className={classes.formControl}>
          <Select value={timeLine} onChange={handelChange}>
            <MenuItem value="year">Year</MenuItem>
            <MenuItem value="month">Month</MenuItem>
            <MenuItem value="week">Week</MenuItem>
          </Select>
        </FormControl>
      </div> */}

      <Grid container>
        <Grid item xs={12} md={4}>
          <div className={classes.doughnutChartWrapper}>
            <Doughnut data={doughnutChartData} options={doughnutChartOption} plugins={plugins} />
            <Typography variant="button" align="center" className={classes.text}>
              00:43 Seconds
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={8}>
          <div className={classes.textWrapper}>
            <Typography align="center">Weekly Avg: 0.58 Seconds</Typography>
          </div>
          <ChartWrapper>
            <Line options={lineChartOptions} data={LineChartData} height={300} />
          </ChartWrapper>
        </Grid>
      </Grid>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { avgSpeed } = overview;
  return { ...avgSpeed };
};

const mapDispatchToProps = { setTabExpend, setTimeLine };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AvgSpeed));
